import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
  } from '@angular/core';
  
  import {
    RedirectConditionDto,
    RedirectConditionOperatorEnum,
    RedirectLogicalOperatorEnum,
    RedirectTriggerRulesDto
  } from '../../models/search-redirectRules';
  
  @Component({
    selector: 'app-redirect-rules-table',
    templateUrl: './redirect-rules-table.component.html',
    styleUrls: ['./redirect-rules-table.component.scss'],
  })
  export class RedirectRulesTableComponent implements OnChanges {
  
    @Input() isEditMode = false;
    @Input() triggerRules?: RedirectTriggerRulesDto;
  
    @Output() triggerRulesChange = new EventEmitter<RedirectTriggerRulesDto>();
  
    RedirectLogicalOperatorEnum = RedirectLogicalOperatorEnum;
    RedirectConditionOperatorEnum = RedirectConditionOperatorEnum;
  
    logicalOperator: RedirectLogicalOperatorEnum = RedirectLogicalOperatorEnum.OR;
    openMenuIndex: number | null = null;
    uiLogicalOperator: any;
    uiConditionOperators: any[] = [];
    conditions: RedirectConditionDto[] = [
      { term: '', operator: RedirectConditionOperatorEnum.IS }
    ];
    logicalOperatorOptions = [
        { label: 'OR', value: RedirectLogicalOperatorEnum.OR },
        { label: 'AND', value: RedirectLogicalOperatorEnum.AND }
      ];
      
      conditionOperatorOptions = [
        { label: 'Is', value: RedirectConditionOperatorEnum.IS },
        { label: 'Contains', value: RedirectConditionOperatorEnum.CONTAINS }
      ];
      
    /* ==============================
     * Ciclo de vida
     * ============================== */
    
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['triggerRules'] && this.triggerRules) {
        this.loadTriggerRules(this.triggerRules);
      }
    }
  
    /* ==============================
     * CRUD de condiciones
     * ============================== */
  
    addCondition(): void {
      this.conditions.push({
        term: '',
        operator: RedirectConditionOperatorEnum.IS,
      });
  
      this.emitChanges();
    }
  
    duplicateCondition(index: number): void {
      const copy = { ...this.conditions[index] };
      this.conditions.splice(index + 1, 0, copy);
      this.openMenuIndex = null;
      this.emitChanges();
    }
  
    removeCondition(index: number): void {
      this.conditions.splice(index, 1);
      this.openMenuIndex = null;
  
      if (this.conditions.length === 0) {
        this.addCondition();
        return;
      }
  
      this.emitChanges();
    }
  
    clearConditions(): void {
      this.logicalOperator = RedirectLogicalOperatorEnum.OR;
      this.conditions = [
        { term: '', operator: RedirectConditionOperatorEnum.IS }
      ];
  
      this.emitChanges();
    }
  
    /* ==============================
     * UI helpers
     * ============================== */
  
    toggleMenu(index: number, event: MouseEvent): void {
      event.stopPropagation();
      this.openMenuIndex = this.openMenuIndex === index ? null : index;
    }
    
getLogicalOperatorOption(value: RedirectLogicalOperatorEnum) {
    console.log('value getLogicalOperatorOption', value);
    return this.logicalOperatorOptions.find(o => o.value === value) || null;
  }
  
  getConditionOperatorOption(value: RedirectConditionOperatorEnum) {
    console.log('value getConditionOperatorOption', value);

    return this.conditionOperatorOptions.find(o => o.value === value) || null;
  }
      
    closeMenus(): void {
      this.openMenuIndex = null;
    }
  
    onChange(): void {
      this.emitChanges();
    }
  
    /* ==============================
     * Normalización backend → frontend
     * ============================== */
  
    private loadTriggerRules(rules: RedirectTriggerRulesDto): void {
        // 1️⃣ Logical operator
        this.logicalOperator =
          rules.logicalOperator?.toUpperCase() === 'AND'
            ? RedirectLogicalOperatorEnum.AND
            : RedirectLogicalOperatorEnum.OR;
      
        this.uiLogicalOperator =
          this.logicalOperatorOptions.find(o => o.value === this.logicalOperator) || null;
      
        // 2️⃣ Conditions
        this.conditions = rules.conditions.map(c => ({
          term: c.term,
          operator:
            c.operator?.toUpperCase() === 'CONTAINS'
              ? RedirectConditionOperatorEnum.CONTAINS
              : RedirectConditionOperatorEnum.IS
        }));
      
        // 3️⃣ UI operators (🔥 ESTO FALTABA)
        this.uiConditionOperators = this.conditions.map(c =>
          this.conditionOperatorOptions.find(o => o.value === c.operator) || null
        );
      }
      
  
    /* ==============================
     * Emit
     * ============================== */
   
      
    private emitChanges(): void {
      this.triggerRulesChange.emit({
        logicalOperator: this.logicalOperator,
        conditions: this.conditions.map(c => ({
          term: c.term?.trim() || '',
          operator: c.operator,
        })),
      });
    }
  }
  